<template>
  <div ref="retrievalResultContainer" class="retrieval-result-container">
    <div class="title" v-html="$t('retrieval.retrievalCount',[pagingInfo.sentCount])"></div>
    <ul class="retrieval-result-list">
      <li class="retrieval-result-list_item" v-for="item in list" :key="item.id">
        <div class="sent-warp"
             :class="{'first-br':sentIndex === 0,'last-br':sentIndex===item.sentList.length-1}"
             v-for="(sent,sentIndex) in item.sentList" :key="sent.id">
          <div :class="specialLangClassName(item.sourceLang)" class="source-lang"
               v-html="sent.sourceSent?sent.sourceSent:''"></div>
          <div :class="specialLangClassName(item.targetLang)" class="target-lang"
               v-html="sent.targetSent?sent.targetSent:''"></div>
        </div>
        <div class="bank-info">
          <el-tooltip effect="dark" :disabled="tipsDisabled" :content="`《${item.name}》`"
                      placement="top-start">
            <div class="left" @mouseover="mouseOverShowTips($event)"
                 @click="handlePushCorpusDetail(item)">《{{item.name}}》</div>
          </el-tooltip>
          <div class="right">
            <div class="right-item bankType" v-show="item.corpusType">
              {{item.corpusType==='memory'?$t('newProjectV2.memoryBank'):item.corpusType==='term'?$t('newProjectV2.termBank'):''}}
            </div>
            <el-tooltip effect="dark" :disabled="tipsDisabled"
                        :content="$i18n.locale === 'zh' ? item.langDesc.replace('>',' — ') : getEnlang(item.sourceLang,item.targetLang)"
                        placement="top-start">
              <div class="right-item langDesc" v-show="item.langDesc"
                   @mouseover="mouseOverShowTips($event)">
                {{$i18n.locale === 'zh' ? item.langDesc.replace('>',' - ') : getEnlang(item.sourceLang,item.targetLang)}}
              </div>
            </el-tooltip>
            <div class="right-item domain" v-show="item.domainName">
              {{$i18n.locale === 'zh' ? item.domainName : getEnDomain(item.domainCode)}}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ExceedTips from '../../../mixins/ExceedTips.js';
export default {
  name: 'RetrievalContainer',
  mixins: [ExceedTips],
  props: {
    // 列表
    data: {
      type: Array,
      default: () => []
    },
    pagingInfo: {
      type: Object,
      default: () => { }
    },
    keyword: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      // 全局setting.js 变量 特殊语种
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      list: []
    }
  },
  watch: {
    data: {
      handler(newVal) {
        this.list = newVal ? JSON.parse(JSON.stringify(newVal)) : []
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const root = this.$refs.retrievalResultContainer
      root.addEventListener('scroll', this.handleScrollList)
    })
  },
  methods: {
    specialLangClassName(lang) {
      return this.SPECIAL_LANGUAGE.indexOf(lang) !== -1 ? 'right-view' : ''
    },
    handleScrollList(e) {
      const target = e.target
      if (target.clientHeight + target.scrollTop === target.scrollHeight) {
        this.$emit('handleScrollList')
      }
    },
    handlePushCorpusDetail(row) {
      //  JSON.parse(localStorage.getItem('historyRetrieval'))[0].keyword
      const source_sent = this.keyword
      this.$router.push({
        name: row.corpusType === 'memory' ? 'corpusmemoryDetail' : row.corpusType === 'term' ? 'corpustermbankDetail' : '',
        query: {
          key: this.$Base64.encode(JSON.stringify({
            row
          }))
        },
        params: {
          key: this.$Base64.encode(JSON.stringify({
            source_sent
          }))
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.retrieval-result-container {
  padding: 0 0.72em;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: auto;
  .title {
    // padding: 0 0.72em;
    text-align: left;
  }
  .retrieval-result-list {
    flex: 1;
    // padding: 0 0.72em;
    // overflow-y: auto;
    &_item {
      margin-top: 1.43em;
      // border-top: 1px solid #e5e7eb;
      .sent-warp {
        display: flex;
        &:hover {
          background-color: #f6f7fb;
        }
        .right-view {
          text-align: right !important;
          direction: rtl;
          unicode-bidi: bidi-override;
        }
        .source-lang,
        .target-lang {
          padding: 1em 0.86em;
          flex: 1;
          word-break: break-word;
          text-align: left;
          color: #333;
        }
        .source-lang {
          border: 1px solid #e5e7eb;
          border-top: none;
        }
        .target-lang {
          border-bottom: 1px solid #e5e7eb;
          border-right: 1px solid #e5e7eb;
        }
      }
      .first-br {
        .source-lang {
          border-top: 1px solid #e5e7eb;
          border-radius: 4px 0 0 0;
        }
        .target-lang {
          border-top: 1px solid #e5e7eb;
          border-radius: 0 4px 0 0;
        }
      }
      .last-br {
        .source-lang {
          border-radius: 0 0 0 4px;
        }
        .target-lang {
          border-radius: 0 0 4px 0;
        }
      }
      .bank-info {
        padding: 1.3em 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e5e7eb;
        .left {
          max-width: 50%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: #454545;
          cursor: pointer;
          &:hover {
            // text-decoration: underline;
            color: #0078fc;
            border-bottom: 1px solid #0078fc;
          }
        }
        .right {
          padding-right: 1.43em;
          display: flex;
          .right-item + .right-item {
            margin-left: 1.43em;
          }
          &-item {
            padding: 2px 8px;
            &:nth-child(1) {
              background-color: #e5f1ff;
              color: #0078fc;
            }
            &:nth-child(2) {
              max-width: 220px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              background-color: #fff6eb;
              color: #ffa43b;
            }
            &:nth-child(3) {
              background-color: #ffeeee;
              color: #ff5a5a;
            }
          }
        }
      }
    }
  }
}
</style>